
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 3C0 1.34315 1.34315 0 3 0H22C23.6569 0 25 1.34315 25 3V22C25 23.6569 23.6569 25 22 25H3C1.34315 25 0 23.6569 0 22V3Z","fill":"#F9D03E"}}),_c('path',{attrs:{"d":"M6.6665 18.3333C6.6665 17.8731 7.0396 17.5 7.49984 17.5H17.4998C17.9601 17.5 18.3332 17.8731 18.3332 18.3333C18.3332 18.7936 17.9601 19.1667 17.4998 19.1667H7.49984C7.0396 19.1667 6.6665 18.7936 6.6665 18.3333Z","fill":"#A68B2C"}}),_c('path',{attrs:{"d":"M9.16683 7.50001C9.16683 8.42048 8.42064 9.16668 7.50016 9.16668C6.57969 9.16668 5.8335 8.42048 5.8335 7.50001C5.8335 6.57954 6.57969 5.83334 7.50016 5.83334C8.42064 5.83334 9.16683 6.57954 9.16683 7.50001Z","fill":"#A68B2C"}}),_c('path',{attrs:{"d":"M19.1668 7.50001C19.1668 8.42048 18.4206 9.16668 17.5002 9.16668C16.5797 9.16668 15.8335 8.42048 15.8335 7.50001C15.8335 6.57954 16.5797 5.83334 17.5002 5.83334C18.4206 5.83334 19.1668 6.57954 19.1668 7.50001Z","fill":"#A68B2C"}})])
          )
        }
      }
    